// @ts-strict-ignore
import { clsx } from 'clsx';
import { Button, Typography } from 'onboarding-components';
import * as React from 'react';
import { SvgIconReact } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import styles from '../index.module.styl';
import { track, TrackingEvent, TrackingProperty } from '../tracking';
import { SetupGuideContext, Step } from '../types';
const StepIndicatorV2 = _ref => {
  let {
    isCompleted,
    moniker,
    children,
    step: targetStep
  } = _ref;
  const {
    step,
    setStep
  } = React.useContext(SetupGuideContext);
  return <div className={clsx({
    [styles.completed]: isCompleted
  }, styles.indicator, {
    [styles.current]: step === targetStep
  })} onClick={() => {
    setStep(targetStep);
    track(TrackingEvent.StepClick, {
      [TrackingProperty.Source]: "SideNav",
      [TrackingProperty.StepName]: targetStep
    });
  }} data-sentry-component="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
      {isCompleted ? <div className={clsx(styles.moniker, styles.completed, {
      [styles.current]: step === targetStep
    })}>
          <SvgIconReact icon='checkmark' />
        </div> : <div className={clsx(styles.moniker, {
      [styles.current]: step === targetStep
    })}>
          <Typography variant='eyebrowSm' weight='bold' style={{
        letterSpacing: 0,
        lineHeight: "100%"
      }}>
            {moniker}
          </Typography>
        </div>}
      <Typography variant='bodySm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="side-nav.tsx">
        {children}
      </Typography>
    </div>;
};
export const SideNavPhase2 = _ref2 => {
  let {
    onClose
  } = _ref2;
  const {
    completed
  } = React.useContext(SetupGuideContext);
  const {
    t
  } = useTranslation();
  return <div className={styles.nav} data-sentry-component="SideNavPhase2" data-sentry-source-file="side-nav.tsx">
      <div>
        <Typography variant='headingMd' style={{
        margin: 0
      }} data-sentry-element="Typography" data-sentry-source-file="side-nav.tsx">
          {t("onboarding.sidenav.setup-guide")}
        </Typography>
        <div className={styles.indicatorGroup}>
          {/* Replace with components */}
          <StepIndicatorV2 isCompleted={completed[Step.GetStarted]} moniker={1} step={Step.GetStarted} data-sentry-element="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
            {t("onboarding.sidenav.get-started")}
          </StepIndicatorV2>
          <StepIndicatorV2 isCompleted={completed[Step.Connect]} moniker={2} step={Step.Connect} data-sentry-element="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
            {t("onboarding.sidenav.connect-data")}
          </StepIndicatorV2>
          <StepIndicatorV2 isCompleted={completed[Step.Verify]} moniker={3} step={Step.Verify} data-sentry-element="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
            {t("onboarding.sidenav.verify-connection")}
          </StepIndicatorV2>
        </div>
      </div>
      <Button onClick={onClose} variant='inline' color='dark' className={styles.footerButton} data-sentry-element="Button" data-sentry-source-file="side-nav.tsx">
        {completed[Step.GetStarted] && completed[Step.Connect] && completed[Step.Verify] ? t("common.close") : t("onboarding.sidenav.skip-for-now")}
      </Button>
    </div>;
};